import React from "react";
import styles from "./styles.scss";
import { Discussion } from "./discussion";

function Loader() {
  return (
    <ul className={styles.discussions}>
      <li className={styles.discussion}>
        <Discussion />
      </li>
      <li className={styles.discussion}>
        <Discussion />
      </li>
      <li className={styles.discussion}>
        <Discussion />
      </li>
    </ul>
  );
}

export { Loader };
